import { FormioCardinalComponent } from './formio-cardinal.component';
import { NgModule } from '@angular/core';

// FormioCardinalComponent es standalone. Este módulo existe sólo para
// compatibilidad con los módulos consumidores existentes (NgModule-based).
@NgModule({
  imports: [FormioCardinalComponent],
  exports: [FormioCardinalComponent]
})
export class FormioCardinalModule { }
